import React from 'react';
import { MenuGroupProps } from '../__base';
import { GlobalPermissionConfig, GlobalUrl } from '@/routers/globalRouters';
import { AdvertisingIcon, BookingIcon, CompanyIcon, HomeIcon, MembersIcon, SettingIcon } from '@/assets/icons/entities/_';

let url = GlobalUrl.PassengerApp;
export const PassengerAppMenu: MenuGroupProps[] = [
  {
    groupName: 'menu.MainMenu',
    items: [
      {
        icon: <HomeIcon />,
        title: 'menu.Dashboard',
        key: 'dashboard',
        to: url.Dashboard,
        permissions: GlobalPermissionConfig.__getPermission(url.Dashboard),
      },
    ],
  },
  {
    groupName: 'menu.SystemSettings',
    items: [
      {
        icon: <BookingIcon />,
        title: 'menu.Bookings',
        key: 'bookings',
        to: url.Bookings,
        permissions: GlobalPermissionConfig.__getPermission(url.Bookings),
      },
      {
        icon: <MembersIcon />,
        title: 'menu.PassengerAppUsers',
        key: 'passengers',
        to: url.Passengers,
        permissions: GlobalPermissionConfig.__getPermission(url.Passengers),
      },
      {
        icon: <AdvertisingIcon />,
        title: 'menu.Advertising',
        key: 'advertising',
        to: url.Advertising,
        permissions: GlobalPermissionConfig.__getPermission(url.Advertising),
      },
      {
        icon: <CompanyIcon />,
        title: 'menu.Discounts',
        key: 'discount',
        to: url.Discounts,
        permissions: GlobalPermissionConfig.__getPermission(url.Discounts),
      },
      {
        icon: <SettingIcon />,
        title: 'menu.PassengerAppSettings',
        key: 'setting',
        to: url.Settings,
        permissions: GlobalPermissionConfig.__getPermission(url.Settings),
      },
    ],
  },
];
